import { boot } from 'quasar/wrappers'
import VueGtag from 'vue-gtag'


export default boot(async ({ app }) => {
	function gtag() {
		const options = {
			config: { id: 'UA-53707923-3' },
			includes: []
		}
		if (process.env.ID_GOOGLE_ANALYTICS !== '') options.includes.push(process.env.ID_GOOGLE_ANALYTICS)
		if (process.env.ID_GOOGLE_ANALYTICS_CLIENT !== '') options.includes.push(process.env.ID_GOOGLE_ANALYTICS_CLIENT)
		app.use( VueGtag, options )
	}

	app.config.globalProperties.$gtag = gtag
})
